module.exports = __webpack_public_path__ + "static/media/roles.0f066f28.png";